import messages from '@/plugins/i18n/locales/fi'
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

const supportedLocales = ['fi', 'sv', 'en', 'lt'];

export const i18n = new VueI18n({
  locale: 'fi', // set locale
  fallbackLocale: 'fi',
  messages: {
    "fi": messages
  }, // set locale messages
})

export async function initLang() {
  const lang = getLanguage("en");

  if (lang !== 'fi') {
    await loadLanguageAsync(lang);
  }
}

const loadedLanguages = ['fi']; // our default language that is preloaded

function setI18nLanguage(lang) {
  i18n.locale = lang

  persistLanguage(lang);

  return lang
}

function persistLanguage(lang) {
  localStorage.setItem("lang", lang);
}

function getLanguage(fallbackLang) {

  const lang = localStorage.getItem("lang");
  if (lang)
    return lang;

  const browserLang = tryGetBrowserLang();
  if (browserLang) {
    if (supportedLocales.indexOf(browserLang) > -1) {
      return browserLang;
    }
  }

  return fallbackLang;
}

function tryGetBrowserLang() {
  try {
    const userLang = navigator.languages && navigator.languages.length
      ? navigator.languages[0]
      : navigator.language || navigator.userLanguage;

    return userLang.split('-')[0];
  }
  catch { }
  return null;
}

export function loadLanguageAsync(lang) {
  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language hasn't been loaded yet
  /* eslint-disable prefer-template */
  return import(/* webpackChunkName: "lang-[request]" */ '@/plugins/i18n/locales/' + lang + '.js').then(msgs => {
    i18n.setLocaleMessage(lang, msgs.default)
    loadedLanguages.push(lang)

    return setI18nLanguage(lang)
  })
  /* eslint-enable */
}